import React, { useState, useEffect } from "react";
import useApiServices from "../../utils/useApiServices";
import {
  FETCH_ALL_MERCHANT_VALIDATIONS,
  GET_ALL_SID_,
  GET_ALL_SID_BY_VEHICLE,
  SAVE_AMOUNT_RULE,
  SAVE_WHITELIST_AMOUNT_RULE,
} from "../../utils/constant";
import swal from "sweetalert";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CustomTip from "../../common/CustomToolTip/CustomTip";
import { Select } from "@mui/material";

import { Autocomplete, TextField, Chip } from "@mui/material";
const WhitelistingForm = ({ handleClose, getAllMerchantsWithTheirRules }) => {
  const { apiCallFnforGet, apiCallFnforPost } = useApiServices();
  const [merchantList, setMerchantList] = useState([]);
  const [selectedMerchant, setSelectedMerchant] = useState("");
  const [midList, setMidList] = useState([]);
  const [cards, setCards] = useState([
    {
      processor: "",
      sidList: [],
      selectedSid: [],
      ruleName: "",
      remarkMessage: "",
      txnMinAmount: "",
      txnMaxAmount: "",
    },
  ]);
  const [payload, setPayload] = useState([]);
  const [priority, setPriority] = useState(0);

  //   const FetchVehicleMasterByServiceCharge = async () => {
  //     const response = await apiCallFnforPost(FETCH_VEHICLE_BY_SERVICE_TYPE, {
  //       serviceType: "UPI",
  //     });
  //     if (response.statusCode === 200) {
  //       setVehicles(response?.data);
  //     } else {
  //       setVehicles([]);
  //     }
  //   };

  const getAllSIDs = async (mid, index) => {
    try {
      if (mid) {
        const response = await apiCallFnforGet(`${GET_ALL_SID_}${mid}`);
        if (response?.statusCode === 200) {
          setMidList(response?.data);
        } else if (response?.statusCode === 306) {
          setMidList([]);
        } else {
          setMidList([]);
        }
      }
    } catch (error) {
      console.error("Error fetching SIDs", error);
    }
  };

  useEffect(() => {
    getAllSIDs(selectedMerchant);
  }, [selectedMerchant]);

  const handleSidChange1 = (index, selectedSids) => {
    console.log(selectedSids);
    setCards((prevCards) => {
      const newCards = [...prevCards];
      newCards[index] = {
        ...newCards[index],
        selectedSid: selectedSids,
      };
      return newCards;
    });
  };

  const handleSidChange = (cardIndex, newSelectedSidArray) => {
    const updatedCards = [...cards]; // assuming you have cards state
    updatedCards[cardIndex].selectedSid = newSelectedSidArray;
    setCards(updatedCards); // update the state
  };

  const handleRouteChange = (index, ruleName) => {
    setCards((prevCards) => {
      const newCards = [...prevCards];
      newCards[index].ruleName = ruleName;
      return newCards;
    });
  };

  const handleMinAmountChange = (index, value) => {
    setCards((prevCards) => {
      const newCards = [...prevCards];
      newCards[index].txnMinAmount = value;
      return newCards;
    });
  };

  const handleMaxAmountChange = (index, value) => {
    setCards((prevCards) => {
      const newCards = [...prevCards];
      newCards[index].txnMaxAmount = value;
      return newCards;
    });
  };

  const addCard = () => {
    setCards((prevCards) => [
      ...prevCards,
      {
        processor: "",
        sidList: [],
        selectedSid: [],
        ruleName: "",
        remarkMessage: "",
        txnMinAmount: "",
        txnMaxAmount: "",
      },
    ]);
  };

  const removeCard = (index) => {
    setCards((prevCards) => prevCards.filter((_, i) => i !== index));
  };

  const validateAmounts = () => {
    for (const card of cards) {
      const minAmount = parseFloat(card.txnMinAmount) || 0;
      const maxAmount = parseFloat(card.txnMaxAmount) || 0;
      if (minAmount > maxAmount) {
        return false; // Validation failed
      }
    }
    return true; // Validation passed
  };

  const updatePayload = () => {
    const newPayload = cards.map((card, index) => ({
      domain: null,
      mid: selectedMerchant,
      processor: card.processor ? card.processor : "", // Update processor value
      priority: index + 1, // Set priority based on index + 1
      remarkMessage: card.remarkMessage,
      requestMode: "",
      sidList: card?.selectedSid?.map((item) => item?.id),
      ruleName: card.ruleName,
      txnMaxAmount: card.txnMaxAmount,
      txnMinAmount: card.txnMinAmount,
    }));
    setPayload(newPayload);
  };

  useEffect(() => {
    updatePayload();
  }, [cards, selectedMerchant]);

  const submitAmountListRules = async () => {
    console.log(payload);
    // return;
    if (!selectedMerchant) {
      return swal({
        title: "Alert",
        text: "Please select merchant",
        icon: "warning",
      });
    }
    if (!validateAmounts()) {
      return swal({
        title: "Alert",
        text: "Minimum amount should not be greater than maximum amount for any rule",
        icon: "warning",
      });
    }

    // Check if all required fields are filled
    const isAnyCardIncomplete = cards.some(
      (card) => !card.txnMinAmount || !card.txnMaxAmount
    );

    if (isAnyCardIncomplete) {
      return swal({
        title: "Alert",
        text: "Please fill in all required fields (Minimum Amount, Maximum Amount, Request Mode) for every card.",
        icon: "warning",
      });
    }

    const validationErrors = cards.some(
      (card) => !card.processor && !card.selectedSid && !card.ruleName
    );
    if (validationErrors) {
      return swal({
        title: "Alert",
        text: "Please select Processor and SID for all cards where Route is selected",
        icon: "warning",
      });
    }
    try {
      const response = await apiCallFnforPost(
        SAVE_WHITELIST_AMOUNT_RULE,
        payload
      );
      if (response?.statusCode === 200) {
        setCards([
          {
            processor: "",
            sidList: [],
            selectedSid: [],
            ruleName: "", // Reset to default
            requestMode: "",
            remarkMessage: "",
            txnMinAmount: "",
            txnMaxAmount: "",
          },
        ]);
        setPriority(0); // Reset priority
        swal({
          title: "Alert",
          text: "Transaction amount rule saved successfully",
          icon: "success",
        });
        setTimeout(() => {
          getAllMerchantsWithTheirRules();
          // handleClose();
        }, 2000);
        handleClose();
      }
    } catch (error) {
      console.error("Error submitting rules", error);
      return swal({
        title: "Alert",
        text: "Failed to save the transaction amount rule.",
        icon: "error",
      });
    }
  };

  const getAllMerchants = async () => {
    try {
      const response = await apiCallFnforGet(FETCH_ALL_MERCHANT_VALIDATIONS);
      if (response?.statusCode === 200) {
        setMerchantList(response?.data);
      }
    } catch (error) {
      console.error("Error fetching merchants", error);
      swal({
        title: "Alert",
        text: "No data found",
        icon: "warning",
      });
    }
  };

  useEffect(() => {
    getAllMerchants();
    // FetchVehicleMasterByServiceCharge();
  }, []);

  // console.log('payload', payload);

  return (
    <div className="container-fluid">
      <div className="d-flex justify-content-between align-items-center">
        <div className="mb-3 col-md-3">
          <label className="form-label">Select A Merchant</label>
          <select
            name="merchantMid"
            className="form-control form-control-sm"
            value={selectedMerchant} // Keep the selected merchant value
            onChange={(e) => setSelectedMerchant(e.target?.value)}
          >
            <option>Select A Merchant</option>
            {merchantList?.map((mr, index) => (
              <option key={index} value={mr.mid}>
                {mr.mid} :- {mr.merchantName}
              </option>
            ))}
          </select>
        </div>

        <div className="d-flex gap-2 justify-content-end mt-3 me-4 mb-2">
          <CustomTip size="18" placement="top" title="Frm rules">
            <div className="" onClick={addCard}>
              <AddCircleOutlineIcon fontSize="large" />
            </div>
          </CustomTip>
        </div>
      </div>

      {cards.map((card, index) => (
        <div
          className="row border border-light rounded p-2 mt-2 position-relative"
          key={index}
          id="frm_card"
        >
          <button
            type="button"
            className="btn-close position-absolute top-0 end-0 m-2"
            onClick={() => removeCard(index)}
          >
            {/* <CloseIcon /> */}
          </button>
          <div>
            <div className="col-12 d-flex justify-content-center">
              <div className="col-12">
                <div className="row">
                  <div className="mb-3 col-md-3">
                    <label className="form-label">Minimum Amount</label>
                    <input
                      className="form-control form-control-sm"
                      type="text"
                      placeholder="Minimum amount"
                      value={card.txnMinAmount}
                      onChange={(e) =>
                        handleMinAmountChange(index, e.target.value)
                      }
                    />
                  </div>
                  <div className="mb-3 col-md-3">
                    <label className="form-label">Maximum Amount</label>
                    <input
                      className="form-control form-control-sm"
                      type="text"
                      placeholder="Maximum amount"
                      value={card.txnMaxAmount}
                      onChange={(e) =>
                        handleMaxAmountChange(index, e.target.value)
                      }
                    />
                  </div>

                  <div className="mb-3 col-md-3">
                    <label className="form-label">Action</label>
                    <select
                      className="default-select form-control form-control-sm wide"
                      value={card.ruleName}
                      onChange={(e) => handleRouteChange(index, e.target.value)}
                    >
                      <option value={""}>Select</option>
                      <option value={"W1"}>W1</option>
                      <option value={"W2"}>W2</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 h-auto">
              <div className="row h-auto">
                <div style={{ marginBottom: "16px", width: "100%" }}>
                  {" "}
                  {/* Adjust width as needed */}
                  <Autocomplete
                    multiple // Enables multiple selection
                    id={`select-sid-autocomplete-${index}`} // Unique ID for accessibility
                    options={midList}
                    getOptionLabel={(option) => `${option?.sid} :- ${option?.vehicleName}`} // How to display each option in the list
                    value={card?.selectedSid} // Controlled component: current selected values
                    onChange={(event, newValue) => {
                      console.log(newValue);
                      handleSidChange(index, newValue);
                    }}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => (
                        <Chip
                          key={option?.id || index} // fallback to index if no ID
                          label={`${option?.sid} :- ${option?.vehicleName}`}
                          {...getTagProps({ index })}
                        />
                      ))
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select SID"
                        placeholder="Search or select SIDs"
                        variant="outlined" // Or 'filled', 'standard'
                        // size="small" // Adjust size as needed
                        fullWidth
                      />
                    )}
                    disableCloseOnSelect // Keeps the dropdown open after selecting an item
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}

      <div className="card-footer d-flex justify-content-between align-items-center">
        <div></div>
        <div>
          <button className="btn btn-primary" onClick={submitAmountListRules}>
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default WhitelistingForm;
